import React from 'react';
import { HashLink } from 'react-router-hash-link';
import './Footer.css';
import siteLogoWhite from '../../assets/images/icon/site_logo_white.svg';
import xLogo from '../../assets/images/icon/x_logo.png';
import noteLogo from '../../assets/images/icon/note_logo.png';
import githubLogo from '../../assets/images/icon/github_logo.svg';


function Footer() {
  return (
    <footer id="footer">
      <div className="footer-content">
        <div className="footer-menu">
          <a className="footer-logo" href="/">
            <img
              src={siteLogoWhite}
              alt="津田千穂のポートフォリオサイトのロゴ"
            />
          </a>

          <nav>
            <ul className="footer-menu-list">
            <li>
                <HashLink smooth className="footer-menu-item" to="/#hotpick">
                  HOT PICK
                </HashLink>
              </li>
              <li>
                <HashLink smooth className="footer-menu-item" to="/#works">
                  WORKS
                </HashLink>
              </li>
              <li>
                <HashLink smooth className="footer-menu-item" to="/#about">
                  ABOUT
                </HashLink>
              </li>
              {/*
              <li>
                <HashLink smooth className="footer-menu-item" to="/#blog">
                  BLOG
                </HashLink>
              </li>
               */}
            </ul>
          </nav>
        </div>

        <ul className="sns-btn">
          <li>
            <a
              className="sns-btn-link"
              href="https://x.com/momo1530889"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="x"
                src={xLogo}
                alt="X"
              />
            </a>
          </li>
          <li>
            <a
              className="sns-btn-link"
              href="https://note.com/nice_camel636"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="note"
                src={noteLogo}
                alt="note"
              />
            </a>
          </li>
          <li>
            <a
              className="sns-btn-link"
              href="https://github.com/chiho883/chatbot"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="github"
                src={githubLogo}
                alt="GitHub"
              />
            </a>
          </li>
        </ul>

        <div className="copyright">
          <p>© CHIHO TSUDA 2025</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;